import { authHttpClientGet } from "@/services/api/my_axios";

export async function getFileUrl(store, fileKey) {
  let uri = `/file?fileKey=${fileKey}`;

  return await authHttpClientGet(store, uri);
}
